module.exports = __webpack_public_path__ + "img/finland-cerebrovascular-disease-male.36f2faa1.png";